<template>
  <div class="md-layout">
    <div v-if="$route.params.id" id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{formConfig.headerIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color content-wrap">{{recordData? recordData.name : ''}}</h1>
      </div>
    </div>
    <template
      v-if="$route.params.id">

      <md-tabs md-sync-route class="topNavTabs" :class="[
        { 'edit-mode': formConfig.pageMode == 'new' || formConfig.pageMode == 'edit' },
      ]">

        <md-tab id="tab-account" md-label="Account" :to="recordPath" exact>
          <div class="md-card md-layout-item md-small-size-100" >
            <ConfigForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :recordData="recordData" :headerColor="headerColor"></ConfigForm>
          </div>
        </md-tab>

        <md-tab id="tab-cases" md-label="Cases" :to="recordPath + '/cases'">
          <CaseTab
            v-if="$route && $route.meta.tab === 'cases'" 
            :routeParamsId= "$route.params.id" 
            :caseListData= "casesList"
            :caseMapFilter="caseAccountIdFilter"
            :relateRecordInput="caseServiceRelateRecordInput"
          />
        </md-tab>
        <md-tab id="tab-tasks" md-label="Tasks" :to="recordPath + '/tasks'">
          <TaskTab
            v-if="$route && $route.meta.tab === 'tasks'" 
            :routeParamsId= "$route.params.id" 
            :taskListData= "tasksList"
            :filter="taskAccountIdFilter"
          />
        </md-tab>

        <!-- Services tab -->
        <md-tab id="tab-services" md-label="Services" :to="recordPath + '/services'">
          <ElasticList v-if="$route && $route.meta.tab === 'services'" :list.sync="servicesAccountList" :filter="serviceAccountIdFilter" ref="servicesListRef"></ElasticList>

          <md-dialog :md-active.sync="servicesAccountList.showRelatedLinkDialog">
            <md-dialog-title>{{relateServicesList.pageTitle}}</md-dialog-title>
            <md-dialog-content>
              <ElasticList
                v-if="recordData"
                :list.sync="relateServicesList"
                :rawFilter="serviceAccountNullFilter"
                :relateParamsId="$route.params.id"
                relateRecordInputField="serviceAccountId"
              ></ElasticList>

            </md-dialog-content>
            <md-dialog-actions>
              <md-button class="md-theme-default" @click="servicesAccountList.showRelatedLinkDialog = false; servicesAccountList.needsRefresh = true;">Close</md-button>
            </md-dialog-actions>
          </md-dialog>
        </md-tab>

        <md-tab id="tab-people" md-label="People" :to="recordPath + '/people'">
          <ElasticList v-if="$route && $route.meta.tab === 'people'" :list.sync="personsList" :filter="personAccountAccountId" ref="personAccountListRef"></ElasticList>
          <md-dialog :md-active.sync="personsList.showRelatedDialog">
            <md-dialog-title>{{relatePersonsList.pageTitle}}</md-dialog-title>

            <md-dialog-content>
              <ElasticList
                v-if="recordData"
                :list.sync="relatePersonsList"
                :rawFilter="relatePersonAccountFilter"
                :relateRecordInput="{personAccountPersonId: null, personAccountAccountId: $route.params.id, role: null}"
                relateRecordInputField="personAccountPersonId"
                relateRecordInputRole="role"
                ref="accPersonsList"
                :atOpenPopup="onOpenPopup"
              ></ElasticList>
            </md-dialog-content>

            <md-dialog-actions>
              <md-button class="md-theme-default" @click="personsList.showRelatedDialog = false; personsList.needsRefresh = true;">Close</md-button>
            </md-dialog-actions>
          </md-dialog>
           
           <!-- PersonAccount Dialog -->
          <md-dialog class="__customize_person_account" :md-active.sync="relatePersonsList.showPopupModal">
            <md-dialog-title>Add Person</md-dialog-title>
            <md-dialog-content>
              <AccountPersonPopupModal
                :list.sync="relatePersonsList"
                :relateRecordInput="{personAccountPersonId: null, personAccountAccountId: $route.params.id}"
                relateRecordInputField="personAccountPersonId"
                :createNew="relatePersonsList.createNew"
                :atAddNewPerson="onAddNewPerson"
              ></AccountPersonPopupModal>
            </md-dialog-content>
          </md-dialog>
        </md-tab>

        <!-- Products Tab -->
        <md-tab id="tab-products" md-label="Products" :to="recordPath + '/products'">
          <ColapsibleList 
            v-if="$route && $route.meta.tab === 'products'" 
            :list="productsList" 
            :filter="productAccountIdFilter" 
            ref="productsListRef"
            :expandParentList="expandParentList"
            :expandChildList="expandChildList"
          ></ColapsibleList>

          <md-dialog class="__customize" :md-active.sync="productsList.showAddNewModal">
            <md-dialog-title>Add Product</md-dialog-title>

            <md-dialog-content>
              <AddProductModal
                :productAccountAlert ="recordData ? recordData.alert : ''"
                :productAccountId="$route.params.id"
                :productsList.sync="productsList"
              ></AddProductModal>
            </md-dialog-content>
            <!--<md-dialog-actions>
              <md-button class="md-theme-default" @click="productsList.showAddNewModal = false; productsList.needsRefresh = true;">Close</md-button>
            </md-dialog-actions>-->
          </md-dialog>
        </md-tab>
        
      </md-tabs>
    </template>

    <div v-else class="md-tabs topNavTabs md-alignment-left md-theme-default" :class="[
        { 'edit-mode': formConfig.pageMode == 'new' || formConfig.pageMode == 'edit' },
      ]"> 
      <div class="md-content md-tabs-content md-theme-default">
        <div class="md-tabs-container">
          <div id="tab-active" class="md-tab">
            <div class="md-card md-layout-item md-small-size-100">
              <ConfigForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :recordData="recordData" :headerColor="headerColor"></ConfigForm>
            </div>
          </div>
        </div>
      </div>
    </div>

    <md-dialog :md-active.sync="auditLogDialog" class="auditLogModal">
      <md-dialog-title>Audit Log</md-dialog-title>
      <md-dialog-content>
        <AuditLogDialog :list.sync="auditLogList" :filter.sync="auditLogFilter"  ref="auditLogListRef"></AuditLogDialog>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-theme-default" @click="auditLogDialog = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="mergeDialog">
      <md-dialog-title>Merge Account</md-dialog-title>
      <md-dialog-content>
        <AccountMergeComponent
          :list.sync="mergeAccountList"
          :atClose="atCloseMergeDialog"
          :serviceList="accountServices"
        ></AccountMergeComponent>
      </md-dialog-content>
    </md-dialog>
    <md-dialog-alert
      class="__alertDialog"
      :md-active.sync="alertDialog.show"
      :md-title="alertDialog.title"
      :md-content="alertDialog.message" />
  </div>
</template>

<script>
  import Record from '@/mixins/Record';
  import Page from '@/mixins/Page';

  // Form validations
  import { required, numeric, minLength } from "vuelidate/lib/validators";
  
  import Amplify, { API, graphqlOperation } from 'aws-amplify';
  import * as queries from '@/graphql/queries';
  import * as queries_custom from "@/graphql/queries_custom";
  import CaseTab from '@/components/CaseTab';
  import TaskTab from '@/components/TaskTab';
  import AddProductModal from '@/pages/Products/AddProductModal';
  import AccountPersonPopupModal from '@/pages/Accounts/AccountPersonPopupModal';
  import ColapsibleList from "@/components/DynamicForm/ColapsibleList";
  import AuditLogDialog from "@/components/DynamicForm/AuditLogDialog";
  import moment from "moment";
  import AccountMergeComponent from '@/components/DynamicForm/AccountMergeComponent';

  export default {
    name: "account",
    mixins: [Record, Page],
    components: {
      CaseTab,
      TaskTab,
      AddProductModal,
      AccountPersonPopupModal,
      ColapsibleList,
      AuditLogDialog,
      AccountMergeComponent
    },
    computed: {
      caseServiceRelateRecordInput: function() { return {'caseAccountCaseId': null, 'caseAccountAccountId': this.$route.params.id}},
      caseAccountIdFilter: function() { return {"match": {"caseAccountAccountId.keyword": this.$route.params.id }} },
      taskAccountIdFilter: function() {
        return [
          {
            match_phrase: {
              taskAccountAccountId: this.$route.params.id
            },
          },
          {
            term: {
              'esData.task.isAvailable': true,
            },
          },
        ]
      },
      productAccountIdFilter: function () { 
        const mustIds = [];
        const mustNotIds = [];
        const filter = {};
        const id = this.$route.params.id ? this.$route.params.id: -1;

        //match ID
        mustIds.push({ match_phrase: { productAccountId: id } });
        //exclude data
        mustNotIds.push({ match: { isChild: true } });

        //if match IDs exist
        if (mustIds.length) {
          filter.must = [
            { bool: { should: mustIds } }
          ];
        }
        //if exclude IDs exist
        if (mustNotIds.length) {
          filter.must_not = [
            { bool: { should: mustNotIds } }
          ]
        }
        if (Object.keys(filter).length === 0) {
          return;
        }
        return {
          bool: filter
        }
      },
      serviceAccountIdFilter: function () { return {"match_phrase": {"serviceAccountId": this.$route.params.id }}; },
      productServiceIdFilter: function () { return {"match": {"productServiceId.keyword": this.$route.params.id }}; },
      auditLogFilter() {
        return [
          { match_phrase: { modelName: "Account" } },
          { match_phrase: { modelId: this.$route.params.id } },
        ];
      },
      personAccountAccountId: function () { return {"match_phrase": {"personAccountAccountId.keyword": this.$route.params.id }} },
      relatePersonAccountFilter: function () {
        let filter = null;
        const items = this.$reduce(this, 'recordData.persons.items');
        if (items && items.length) {
          const map = {};
          items.reduce((obj, item, index) => {
            const id = this.$reduce(item, 'person.id');
            if (!id) {
              return obj;
            }
            obj.id = { ne: id };
            if (index != (items.length - 1)) {
              obj.and = {};
              return obj.and;
            }
          }, map);
          if (map.id) {
            filter = { filter: map };
          }
        }
        return filter;
      },
      serviceAccountNullFilter: function() {                 
          return { filter: {esQuery: JSON.stringify(
            {"bool":{"must_not":{"exists":{"field":"serviceAccountId"}}}}
            )}
          }    
      },
    },
    beforeRouteLeave (to, from, next) {
      this.$notifyClear(this.noticationTimeStamp);
      this.noticationTimeStamp = [];
      next();
    },
    data() {
      return {
        alertDialog: {
          show: false,
          title: "",
          message: "",
        },
        shouldShowAlertMessage: true,
        noticationTimeStamp: [],
        showAddProductModal: false,
        uniqueNameValidatorTimeoutId: null,
        isFirstTimeUniqueNameCheck: true,
        addrPhysicalCountry: "",
        mailingCountry: "",
        expandParentList: [],
        expandChildList: [],
        auditLogDialog: false,
        mergeDialog: false,
        atCloseMergeDialog: this.closeMergeDialog,
        mergeAccountList: {
          editPath: "accounts",
          pageTitle: "Select a Target Account",
          listQueryId: "searchService",
          updateServiceMutationId: "updateService",
          updateProductMutationId: "updateProduct",
          mergeMessageTitle: "Are you sure ? selected services will get moved to \n \"{objectName}\" account.",
          mergeMessageText: "",
          mergeMessageNameFields: ['name'],
          mergeAccounttatus: "Merged",
          pagination: {
            perPage: 999,
            currentPage: 1,
            perPageOptions: [],
            total: 0
          }
        },
        auditLogList: {
          class: 'auditLogList',
          skipCardLayout: true,
          hideListHeader: true,
          hideNewRecordButton: true,
          searchRecordsInput: false,
          hideActionColumn: true,
          pageTitle: "Change History",
          listQueryId: "searchChangesCustom",
          responseFieldName: "searchChanges",
          deleteQueryId: "deleteChange",
          deleteMessageTitle: "Are you sure you want to remove this record?",
          columns: {
            user: { label: "Changed By", sortable: false, size: 10 },
            fieldName: { label: "Field", sortable: false, size: 10 },
            oldValue: { label: "Old Value", sortable: false, size: 10 },
            newValue: { label: "New Value", sortable: false, size: 10 },
            createdAt: { label: "Change Date", sortable: true, dateFilter: true, size: 15 },
            //action: { label: "Activity", sortable: false, size: 10 },
            //change: { label: "Change", sortable: false, format: "json", size: 55 },
          },
          //hyperlink config based on admin role
          linkConfigs: this.$Session && this.$Session.isAdminGroupMember ? [
            {
              name: 'user',
              hrefCallback: (column, name, item) => {               
                return '#/users/' + (item.user ? item.userId : "" );
              },
              titleCallback: (column, name, item) => {                           
                  return item.user                
              },
            }
          ] : [],          
          currentSort: "createdAt",
          currentSortOrder: "asc",
          pagination: {
            perPage: 10,
            currentPage: 1,
            total: 0,
            perPageOptions: [5, 10, 20, 25, 50],
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: "createdAt",
            sortDir: "desc",
            perPage: 10,
          },
          tableData: [],
          searchedData: [],
          fuseSearch: null,
          assigneeList: [],
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchChanges && data.searchChanges.items.length) {
              let items = data.searchChanges.items;
              items.forEach((item) => {
                /** Format user and change for display */
                // item.userId = item.user ? item.user.id : '';
                // item.user = item.user
                //   ? item.user.given_name + " " + item.user.family_name
                //   : item.owner;
                // item.action = item.action ? item.action.charAt(0).toUpperCase() + item.action.slice(1) : '';
                // item.createdAt = moment(String(item.createdAt)).format("MMM DD, YYYY h:mm:ss a");

                if (item.change) {
                  //let change = JSON.stringify(JSON.parse(item.change),null,2);
                  let parseItem = JSON.parse(item.change);

                  item.userId = item.user ? item.user.id : '';
                  item.user = item.user ? item.user.given_name + ' ' + item.user.family_name : item.owner;

                  Object.keys(parseItem).forEach((k) => {
                    if (k !== "old") {
                      let newVal = parseItem[k];
                      let oldVal = "";
                      if (typeof parseItem[k] === 'object') {
                        newVal = JSON.stringify(parseItem[k]);
                      }

                      //if old field exist set oldValue
                      if (parseItem.old) {
                        oldVal = parseItem.old[k];
                        if (typeof parseItem.old[k] === 'object') {
                          oldVal = JSON.stringify(parseItem.old[k]);
                        }
                      }

                      const newItem = {
                        fieldName: k,
                        newValue: newVal,
                        oldValue: oldVal,
                        userId: item.userId,
                        user: item.user,
                        //action: item.action ? item.action.charAt(0).toUpperCase() + item.action.slice(1) : '',
                        createdAt: moment(String(item.createdAt)).format('MMM DD, YYYY h:mm:ss a'),
                        //change: change
                      };
                      result.push(newItem);
                    }
                  });
                }
              });
            }
            return this.orderedAuditLog(result);
          },
        },
        formConfig: {
          hasUpdatedBy: true,
          updatedByFieldName: 'accountUpdatedById',
          isGridResizable: true,
          responseFieldName: 'getAccount',
          atShowAuditLog: this.onShowAuditLog,
          atOpenMergeDialog: this.openMergeDialog,
          openMergeDialog: this.openMergeDialog,
          mergeText: 'Merge Account',
          actions: {
            save: 'createAccount',
            view: 'getAccount',
            edit: 'editAccount',
            new: 'newAccount',
            update: 'updateAccount',
            delete: 'deleteAccount',
          },
          listPath: "/accounts",
          headerIcon: 'work',
          objectName: 'Account',
          editMode: false,
          pageMode: 'new', // can be one of ['new', 'view' 'edit']
          slots: {
            basic: {label: 'Account Information', icon: 'work', layout: {"x":0,"y":0,"w":12,"h":12,"i":"0"}, id: "AccountInformation"},
            banking: {label: 'Banking Information', icon: 'attach_money', layout: {"x":0,"y":17,"w":6,"h":7,"i":"2"}, id: "BankAccount"},
            contact: {label: 'Address', icon: 'place', layout: {"x":0,"y":12,"w":12,"h":12,"i":"1"}, id: "Address"},
            // processor: {label: 'Processor Information', icon: 'memory'}, //select_all
          },
          fields: {
            id: { label: "ID", type: "id", slot: 'basic' },
            nameLegal: { label: "Legal Name", type: "text", slot: 'basic'},
            premier: { label: "Premier", type: "checkbox", slot: 'basic' },
            //IPCorp: { label: "IPCorp", type: "checkbox", slot: 'basic', value: false },
            // status: { label: "Status", type: "text", slot: 'basic' },
            // nameDba: { label: "DBA Name", type: "text", slot: 'basic' },
            name: { label: "DBA Name", type: "text", slot: 'basic', uniqueErrorMessage: 'This Account Name is already in use.' },
            namePrevious: { label: "Previously Known As", type: "text", slot: 'basic' },
            ein: { label: "Federal Tax ID", type: "text", slot: 'basic' },
            accountCompanyId: { label: "Company", type: "autocomplete", slot: 'basic',
              data: [],
              searchTerm: "",
              options: [],
              linkBase: '#/companies/',
              setVal: (val) => {
                //this.form.accountCompanyId = val;
                this.$v.form.accountCompanyId.$model = val;
              },
              select: (c) => {(($this) => {
                $this.setVal(c.id);
                $this.searchTerm = c.name;
              })(this.formConfig.fields.accountCompanyId)},
              hasValidation: true,
              isLazyLoadEnabled: true,
              lazyLoadListQueryId: 'searchCompanys',
              lazyLoadResponseFieldName: 'searchCompanys',
              lazyLoadSearchableFields: ['name'],
            },
            
            ownershipType: {label: "Ownership Type", type: "select", slot: "basic", optionType: 'enum',
              // hide: () => {
              //   return !this.form || typeof this.form.accountType === 'undefined' || this.form.accountType !== 'MerchantHQ'
              // },
              options: []
            },
            phoneBusiness: { label: "Business Phone", type: "text", slot: 'basic' },
            phoneSupport: { label: "Customer Service Phone", type: "text", slot: 'basic' },
            phoneFax: { label: "Business Fax", type: "text", slot: 'basic' },
            alert: { label: "Alert Message", type: "textarea", slot: 'basic' },

            bankAccount: {
              label: "Deposit Account",
              type: "json",
              slot: 'banking',
              // id: "BankAccount",
              fields: {
                bankName: { label: "Bank Name", type: "text", slot: 'banking' },
                bankRouting: { label: "Routing Number", type: "text", slot: 'banking' },
                bankAccount: { label: "Account Number", type: "text", slot: 'banking' },
              }
            },
            addressPhysical: {
              label: "Physical Address",
              type: "json",
              slot: 'contact',
              hide: () => {
                return false
              },
              fields: {
                street_address: { label: "Street Address", type: "text", slot: 'contact', removeIfEmpty: true },
                locality: { label: "City", type: "text", slot: 'contact', removeIfEmpty: true }, //City
                region: { label: "State", type: "select", slot: 'contact', removeIfEmpty: true, optionType: 'enum', options: []}, //State
                postal_code: { label: "Postal Code", type: "text", slot: 'contact', removeIfEmpty: true },
                country: {label: "Country", type: "select", slot: "contact", removeIfEmpty: true, optionType: 'enum', options: []},
              }
            },
            addressMailing: {
              label: "Mailing Address",
              type: "json",
              slot: 'contact',
              hide: () => {
                return false;
              },
              fields: {
                street_address: { label: "Street Address", type: "text", slot: 'contact', removeIfEmpty: true },
                locality: { label: "City", type: "text", slot: 'contact', removeIfEmpty: true }, //City
                region: { label: "State", type: "select", slot: 'contact', removeIfEmpty: true, optionType: 'enum', options: []}, //State
                postal_code: { label: "Postal Code", type: "text", slot: 'contact', removeIfEmpty: true },
                country: {label: "Country", type: "select", slot: "contact", removeIfEmpty: true, optionType: 'enum', options: []},
              }
            },
            // processorId: { label: "Processor ID", type: "text", slot: 'processor' },
            // approvalDate: { label: "Approval Date", type: "datepicker", slot: 'processor' },
            // underwritingStatus: { label: "Underwriting Status", type: "text", slot: 'processor' },
            // company: { label: "Company", type: "text", slot: 'basic' },
            // bankAccountFees: { label: "Bank Account for Fees", type: "text", slot: 'banking' },
            // bankAccountDeposits: { label: "Bank Account for Deposits", type: "text", slot: 'banking' },
            // bankAccountChargebacks: { label: "Bank Account for Chargebacks", type: "text", slot: 'banking' },
          },
          editTitleField: 'name'
        },
        form: {
          id: "",
          name: "",
          nameLegal: "",
          premier: "",
          // status: 0,
          namePrevious: "",
          nameDba: "",
          phoneBusiness: "",
          phoneSupport: "",
          phoneFax: "",
          ein: "",
          alert: "",                  
          //IPCorp: false,
          accountCompanyId: "",
          ownershipType: "",
          // processorId: "",
          // approvalDate: null,
          // underwritingStatus: "",
          addressMailing: {
            fields: {
              street_address: "",
              locality: "", //City
              region: "", //State
              postal_code: "",
              country: "",
            }
          },
          addressPhysical: {
            fields: {
              street_address: "",
              locality: "", //City
              region: "", //State
              postal_code: "",
              country: "",
            }
          },
          bankAccount: {
            fields: {
              bankName: "",
              bankRouting: "",
              bankAccount: "",
            }
          },
          // company: "",
          // bankAccountFees: "",
          // bankAccountDeposits: "",
          // bankAccountChargebacks: "",
        },
        accountServices: [],
        servicesList: {
          editPath: "services",
          pageTitle: "Services",
          pageIcon: "style",
          listQueryId: "searchServices",
          deleteQueryId: "deleteService",
          columns: {
            name: { label: "Name", sortable: true },
            accountName: { label: "Account Name", sortable: true },
            createdAt: { label: "Created", sortable: true, dateFilter: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
            this.$c.log('inside services formatResponse');
            this.$c.log(data);

            // if (data && typeof data.getCompany !== 'undefined' && data.getCompany.accounts && data.getCompany.accounts.items.length) {
            //   let accounts = data.getCompany.accounts.items;
            //   accounts.forEach((item) => {
            //     if (item.services.items.length) {
            //       item.services.items.forEach((serviceItem) => {
            //         serviceItem.accountName = item.name;
            //         result.push(serviceItem);
            //       });
            //     }
            //   })
            // }

            if (data && typeof data.searchServices !== 'undefined' && data.searchServices.items && data.searchServices.items.length) {
              let services = data.searchServices.items;
              services.forEach((item) => {
                item.accountName = item.account.name;
                result.push(item);
              })
            }

            return result;
          },
        },
        relateServicesList: {
          hideListHeader: true,
          skipCardLayout: true,
          linkActive: true,
          editPath: "service",
          pageTitle: "Search for Service",
          pageIcon: "service_alt",
          listQueryId: "searchServiceCustoms",
          responseFieldName: "searchServices",
          updateMutationId: "updateService",
          deleteQueryId: "deleteService",
          itemActions: [
            {
              class: "md-just-icon md-simple md-warning",
              classAdded: "item.added? 'check_circle' : 'md-warning'",
              icon: "post_add",
              iconAdded: "check_circle",
              click: "handleLink"
            }
          ],
          columns: {
            name: { label: "Name", sortable: true },
            createdAt: { label: "Created", sortable: true, dateFilter: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
        },
        servicesAccountList: {
          showRelatedLinkDialog: false,
          hideNewRecordButton: true,
          linkRelatedRecord: true,
          showNewExistingButton: true,
          filterFieldName: "serviceAccountId", //for new url
          buildCustomRoute: true, //for new url
          btnLabel: "Add",
          needsRefresh: false,
          linkRows: true,
          itemActions: [
            {
              class: "md-just-icon md-warning md-simple",
              icon: "description",
              click: "handleEdit"
            },
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          editPath: "services",
          pageTitle: "Service",
          pageIcon: "style",
          listQueryId: "searchAccountServiceCustoms",
          listQueryTarget: "searchServices",
          responseFieldName: "searchServices",
          deleteQueryId: "deleteService",
          disassociateRecord: { updateQueryId: "updateService", updateFieldId: "serviceAccountId" },
          // updateQueryId: "updateService",
          // updateQueryIdField: "serviceAccountId",
          // deleteMessageTitle: "Are you sure you want to remove {objectName} from this Account?",
          // deleteMessageText: "",
          columns: {
            name: { label: "DBA Name", sortable: false },
            nameLegal: { label: "Legal Name", sortable: true },
            merchantNumber: { label: "MID", sortable: false },
            status: { label: "Status", sortable: false },  
            // salesRep: { label: "Sales Rep", sortable: false },
            portfolio: { label: "Portfolio", sortable: false },
            phoneBusiness: { label: "Primary Phone", sortable: false },
            physicalAddress: { label: "Physical Address", sortable: false },
            city: { label: "City", sortable: false },
            state: { label: "State", sortable: false },
            IPCorp: { label: "IP Corp", sortable: false },
            isRestructured: { label: "Restructured", sortable: false },
            dateSubmitted: { label: "Submitted", sortable: false  },
            approvalDate: { label: "Approved", sortable: false  },
            dateFirstProcessing: { label: "Processing Live", sortable: false  },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'name',
            sortDir: 'asc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchServices && data.searchServices.items.length) {
              this.$c.log('formatResponse data', data.searchServices.items);

              data.searchServices.items.forEach((_item) => {
                _item.relateRecordId = _item.id;
                _item.phoneBusiness = _item.phoneBusiness ? _item.phoneBusiness : '';
                _item.merchantNumber = _item.merchantNumber ? _item.merchantNumber : '';
                _item.nameLegal = _item.nameLegal ? _item.nameLegal : '';
                _item.name = _item.name ? _item.name : '';
                 _item.IPCorp = _item.IPCorp ? _item.IPCorp : 'false';
                _item.isRestructured = _item.isRestructured ? _item.isRestructured : 'false';
                _item.dateSubmitted = _item.dateSubmitted ? moment(_item.dateSubmitted).format('MM/DD/YYYY') : ""
                _item.approvalDate = _item.approvalDate ? moment(_item.approvalDate).format('MM/DD/YYYY')  : ""
                _item.dateFirstProcessing = _item.dateFirstProcessing ? moment(_item.dateFirstProcessing).format('MM/DD/YYYY') : ""
                
                let itemAddress = _item.addressPhysical;
                if (typeof itemAddress !== 'undefined' && itemAddress) {
                  try {
                    let parsedAddress = JSON.parse(itemAddress);
                    _item.city = this.$reduce(parsedAddress, 'locality');
                    //let region = this.$reduce(parsedAddress, 'region').split('_'); 
                    //_item.state = region && region.length > 1 ? region[1] : this.$reduce(parsedAddress, 'region');
                    let region = parsedAddress.region.replace(/_/g, ' ').substring(2);
                    _item.state = region;
                    _item.physicalAddress = this.$reduce(parsedAddress, 'street_address');
                  } catch (error) {
                    console.log("Services => Json parse error", error)
                  }
                }

                if (typeof _item.portfolios !== 'undefined' && _item.portfolios && _item.portfolios.items && _item.portfolios.items.length) {
                  let firstPortfolio = _item.portfolios.items[0].portfolio.name;
                  _item.portfolio = firstPortfolio;                  
                }

                if (typeof _item.cases !== 'undefined' && _item.cases && _item.cases.items && _item.cases.items.length) {
                  let firstCase = _item.cases.items[0].case;
                  if(firstCase && firstCase.salesreps && firstCase.salesreps && firstCase.salesreps.items && firstCase.salesreps.items.length) {
                    let salesrep = firstCase.salesreps.items[0].salesrep;
                    let givenName = salesrep.given_name ? salesrep.given_name : "";
                    let familyName = salesrep.family_name ? salesrep.family_name : "";
                    let salesrepName = `${givenName} ${familyName}`.trim();
                    _item.salesRep = salesrepName;
                  }
                }

                if (typeof _item.status !== 'undefined' && _item.status) {
                  _item.status = _item.status.replace(/_/g, ' ');
                }
                result.push(_item);
              })
            }
            return result;
          },
        },
        personsList: {
          showRelatedDialog: false,
          linkRows: true,
          itemActions: [
            {
              class: "md-just-icon md-warning md-simple",
              icon: "description",
              click: "handleEdit"
            },
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          editPath: "people",
          pageTitle: "People",
          pageIcon: "people_alt",
          listQueryId: "searchPersonAccounts",
          deleteQueryId: "deletePersonAccount",
          deleteQueryIdField: "relateRecordId",
          deleteMessageTitle: "Are you sure you want to remove {objectName} from this Account?",
          deleteMessageText: "",
          deleteMessageNameFieldsIsInESData: true,
          deleteMessageNameFields: ['person.given_name', 'person.family_name'],
          columns: {
            'esData.person.given_name': { label: "First Name", sortable: false, esNested: true, },
            'esData.person.family_name': { label: "Last Name", sortable: false, esNested: true, },            
            'role': { label: "Role", sortable: false, esNested: false, },
            'title': { label: "Title", sortable: false, esNested: false, },
            'esData.person.phone_mobile': { label: "Mobile", sortable: false, esNested: true, },
            'esData.person.phone_number': { label: "Main Phone", sortable: false, esNested: true, },
            'esData.person.email': { label: "Email", sortable: false, esNested: true, },
            'esData.person.ssn': { label: "SSN", sortable: false, esNested: true, },
            'esData.person.dob': { label: "Birth Date", sortable: false, esNested: true, },
            'ownership': {label: "Ownership %", sortable: false, esNested: false,},
            'esData.person.createdAt': { label: "Created", sortable: false, esNested: true, dateFilter: true },

            //company: { label: "Company", sortable: true, searchable: true, display: true, nested: "name"  }
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          tableData: [],
          searchedData: [],

          fuseSearch: null,
          formatResponse: (data) => {

            let result = [];
            if (data && data.searchPersonAccounts && data.searchPersonAccounts.items.length) {
              // this.$c.log('formatResponse data*******', data.searchPersonAccounts);
              data.searchPersonAccounts.items.forEach((item) => {
                // item.person.relateRecordId = item.id;
                // item.person.role = item.role ? item.role.replace(/_/g, " ") : "";
                // if(item.person.ssn){
                //   item.person.ssn = item.person.ssn.replace(/.(?=.{4})/g, 'X');
                // }   
                // item.person.title = item.title ? item.title : "";
                // item.person.ownership = item.ownership ? item.ownership : "";
                // result.push(item.person);
                item.role = item.role ? item.role.replace(/_/g, " ") : '';
                item.relateRecordId = item.id;
                item.id = item.person.id;
                result.push(item);
              })
            }
            return result;
          },

        },
        relatePersonsList: {
          showRelatedDialog: false,
          showPopupModal: false,
          createNew: false,
          hideListHeader: true,
          openPopup: true,
          skipCardLayout: true,
          editPath: "people",
          pageTitle: "Search for Person",
          pageIcon: "people_alt",
          listQueryId: "searchPersons",
          createMutationId: "createPersonAccount",
          deleteQueryId: "deletePersonAccount",
          itemActions: [
            {
              class: "md-just-icon md-simple md-warning",
              classAdded: "item.added? 'check_circle' : 'md-warning'",
              icon: "post_add",
              iconAdded: "check_circle",
              click: "showPopupModal"
            }
          ],
          columns: {
            given_name: { label: "First Name", sortable: true },
            family_name: { label: "Last Name", sortable: false },
            email: { label: "Email", sortable: false },
            createdAt: { label: "Created", sortable: true, dateFilter: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            this.$c.log(data);
            let result = [];
            let responseKey = 'searchPersons';
            if (data && data[responseKey] !== 'undefined') {
              let items = data[responseKey].items;
              items.forEach((item) => {
                /** Format the addresses for display */
                ['addressPhysical', 'addressMailing'].forEach(addressName => {
                  let itemAddress = item[addressName];
                  if (typeof itemAddress !== 'undefined' && itemAddress) {
                    item[addressName] = this.$format.JsonAddressToString(itemAddress);
                  }
                });
                result.push(item);
              })
            }
            return result;
          },
        },

        productsList: {
          isOfflineSearchEnabled: true,
          searchRecordsInput: false, //disable search input
          hideNewRecordButton: true,
          addNewModal: true,
          showAddNewModal: false,
          editPath: "products",
          pageTitle: "Products",
          pageIcon: "assignment",
          listQueryId: "searchProductsChildrens",
          responseFieldName: "searchProducts",
          deleteQueryId: "deleteProduct",
          deleteRelatedQueryId: "deleteProductChild", //custom deleteProductChild relation
          linkRows: true,
          columns: {
            name: { label: "Name", sortable: true },
            productOptionName: { label: "Type" },
            status: { label: "Status", sortable: true },
            platform: { label: "Platform", sortable: true },
            terminalOrTsysId: { label: "Terminal ID/TSYS TID", sortable: true },
            midV: { label: "MID/V#", sortable: true },
            billToServiceName: { label: "Bill To Service" },
            billingMethod: { label: "Billing Method", sortable: true },
            serial: { label: "Serial", sortable: true },
            createdAt: { label: "Created", sortable: true, dateFilter: true},
            replacementDate: { label: "Replaced", sortable: true}
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          addProductAccountInModal: {},
           formatResponse: (data) => {
            this.$c.log('inside productlist formatResponse');
            this.$c.log(data);
            let result = [];
            
            if (data && typeof data.searchProducts !== 'undefined' && data.searchProducts.items && data.searchProducts.items.length) {
              let products = data.searchProducts.items;
              products.forEach((item) => {
                //check if accountId matches with item accountId
                if (item && item.account && item.account.id && item.account.id == this.$route.params.id) {
                  //set item's null value to blank
                  Object.keys(item).forEach((key) => {
                    if (item[key] === null) {
                      item[key] = '';
                    }
                  });

                  //ATLAS-1740: Output Boolean column value as Active/Inactive
                  item.status = (item.status === true) ? 'Active' : 'Inactive';

                  item.billToServiceName = (item.billToService && item.billToService.name)? item.billToService.name : '';
                  item.productOptionName = (item.productOption && item.productOption.name)? item.productOption.name : '';
                  item.isParentProduct = (item.children && item.children.items && item.children.items.length) ? true: false;
                  //ATLAS-1396: default expand product list
                  if (item.isParentProduct) {
                    this.expandParentList.push(item.id);
                    item.children.items.forEach(el => {
                      if (el.child) {
                        //ATLAS-1740: Output Boolean column value as Active/Inactive
                        el.child.status = (el.child.status === true) ? 'Active' : 'Inactive';

                        //ATLAS-1740: for level 2 child status
                        if (el.child.children && el.child.children.items && el.child.children.items.length) {
                          el.child.children.items.forEach(e => {
                            if (e.child) {
                              e.child.status = (e.child.status === true) ? 'Active' : 'Inactive';
                            }
                          });
                        }
                        this.expandChildList.push(el.child.id);
                      }
                    })
                  }
                  result.push(item);
                }
              });
            }

            const items = result;
            if (items && items.length) {
              const productsRef = this.$refs.productsListRef;
              const sortedItmes = _.sortBy(items, productsRef.currentSort);
              if ('desc' == productsRef.currentSortDir) {
                result = sortedItmes.reverse();
              } else {
                result = sortedItmes;
              }
            }

            return result;
          },
        },
        casesList: {
          listQueryId: "searchCaseAccountsCustom",
          responseFieldName: "searchCaseAccounts",
          listQueryTarget: "searchCaseAccounts",
          deleteQueryId: "deleteCaseAccount",
          deleteMessageNameFieldsIsInESData: true,
          deleteMessageNameFields: ['case.subject'],
          filterListQueryId: "getListCaseStatusEnum",
          relateRecordInputField:"caseAccountCaseId",
          createMutationId: "createCaseAccount",
          caseFromTab: 'Account',
          isSearchRecordsInput: true
        },
        tasksList: {
          listQueryId: "searchTaskAccountsCustoms",
          responseFieldName: "searchTaskAccounts",
          listQueryTarget: "searchTaskAccounts",
          deleteQueryId: "deleteTaskAccount",
          filterListQueryId: "getListTaskStatusEnum",
          defaultStatus: "Open", // ATLAS-962: <Service/Account> <Task> On Service Tasks, make default status filter Open
          // caseMapIdFilter: {"taskAccountAccountId": {"eq": this.$route.params.id }}
          isShowCaseAndAssingeeInList: true, // ATLAS-963: <Service/Account> <Task Tab> Column Changes
        },
        subscriptions: {
          'onUpdateService': {
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onUpdateService');
              let eventRecord = eventData.value.data.onUpdateService;
              if (eventRecord.account && eventRecord.account.id === this.recordData.id) {                
                window.setTimeout(() => {
                  this.$refs.servicesListRef.refresh();
                }, 300);
                /** Force a refresh on the ConfigForm component */
                this.formConfig.refreshRecordData = true;
              } else if(eventRecord.account === null) {
                window.setTimeout(() => {
                  this.$refs.servicesListRef.refresh();
                }, 300);
              }
            },
          },

          'onCreatePersonAccount': {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onCreatePersonAccount');
              let eventRecord = eventData.value.data.onCreatePersonAccount;
              /** Filter out records that do not apply to the Person we are looking at */
              if (this.recordData.id === eventRecord.account.id) {
                this.$c.log('SUBSCRIPTION MATCH!: onCreatePersonAccount');
                //Force a refresh on the ConfigForm component
                window.setTimeout(() => {
                  this.$refs.personAccountListRef.refresh();
                  this.formConfig.refreshRecordData = true;
                }, 3000);
              }
            }
          },
          'onDeletePersonAccount': {
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onDeletePersonAccount');
              let eventRecord = eventData.value.data.onDeletePersonAccount;
              if (this.recordData.id === eventRecord.account.id) {
                this.$c.log('SUBSCRIPTION MATCH: onDeletePersonAccount')
                //Force a refresh on the ConfigForm component
                window.setTimeout(() => {
                  this.$refs.personAccountListRef.refresh();
                  this.formConfig.refreshRecordData = true;                
                }, 3000);
              }
            }
          },
          'onCreateProduct': {
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onCreateProduct');
              this.$c.log("eventData: ", eventData);
              let eventRecord = eventData.value.data.onCreateProduct;

              if (this.recordData.id === eventRecord.account.id) {
                this.$c.log('SUBSCRIPTION MATCH!: onCreateProduct');

                //refresh the list
                window.setTimeout(() => {
                  this.$refs.productsListRef.refresh();
                }, 400);

                //Force a refresh on the ConfigForm component
                this.formConfig.refreshRecordData = true;
              }
            }
          },
          'onDeleteProduct': {
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onDeleteProduct');
              this.$c.log("eventData: ", eventData);
              let eventRecord = eventData.value.data.onDeleteProduct;

              if (this.recordData.id === eventRecord.account.id) {
                this.$c.log('SUBSCRIPTION MATCH: onDeleteProduct');

                //refresh the list
                window.setTimeout(() => {
                  this.$refs.productsListRef.refresh();
                }, 1000);

                //Force a refresh on the ConfigForm component
                this.formConfig.refreshRecordData = true;
              }
            }
          }
        },
        ownershipTypeOptions: [],
        regionOptions: [],
        countryOptions: [],
        autocompleteCompaniesList: []
      }
    },
    validations() {
        return {
          form: {
            id: {},
            name: {
              required, 
              minLength: minLength(3),
              async isUnique(value) {
                if (value.trim().length < 3) {
                  return true;
                }
                const timeoutInterval = this.isFirstTimeUniqueNameCheck ? 0 : 3000;
                this.isFirstTimeUniqueNameCheck = false;
                clearTimeout(this.uniqueNameValidatorTimeoutId);
                return new Promise(async (resolve, reject) => {
                  this.uniqueNameValidatorTimeoutId = setTimeout(async () => {
                    const valueTrimmed = value.trim();
                    const params = { filter: { name: { matchPhrase: valueTrimmed } } };
                    if (this.$route.params.id) {
                      params.filter.and = { id: { ne: this.$route.params.id } };
                    }
                    const query = queries['searchAccounts'];
                    await API.graphql(graphqlOperation(query, params))
                      .then(result => {
                        if (
                          result.data && 
                          result.data.searchAccounts && 
                          result.data.searchAccounts.items
                        ) {
                          const index = result.data.searchAccounts.items.findIndex(_item => {
                            return _item.name.toLowerCase() == valueTrimmed.toLowerCase();
                          });
                          if (-1 === index) {
                            return resolve(true);
                          }
                          return reject(false);
                        }
                        reject(false);
                      })
                      .catch(err => {
                        if (
                          err &&
                          err.errors &&
                          err.errors[0].errorType &&
                          'Elasticsearch:UserIllegalArgumentException' == err.errors[0].errorType
                        ) {
                          resolve(true);
                        }
                        reject(false);
                      });
                  }, timeoutInterval);
                });
              }
            },
            nameLegal: {},
            premier: {},
            // status: {},
            namePrevious: {},
            nameDba: {},
            phoneBusiness: {},
            phoneSupport: {},
            phoneFax: {},
            ein: {},
            alert: {},                        
            //IPCorp: {},
            accountCompanyId: {
              isValid: this.isAccountCompanyIdValid,
            },
            ownershipType: {},
            // processorId: (this.form && this.form.accountType === 'MerchantWithdrawalsOnly' && this.form.premier)? {} : {},
            // approvalDate: {},
            // underwritingStatus: {},
            addressMailing: {
              fields: {
                street_address: {},
                locality: {},
                region: {},
                postal_code: {},
                country: {},
              }
            },
            addressPhysical: {
              fields: {
                street_address: {},
                locality: {},
                region: {},
                postal_code: {},
                country: {},
              }
            },
            bankAccount: {
              fields: {
                bankName: {},
                bankRouting: {},
                bankAccount: {},
              }
            },

            // bankAccountFees: {},
            // bankAccountDeposits: {},
            // bankAccountChargebacks: {},
          }
        }
    },
    methods: {
      updateFormAfter(data) {
        if (typeof data === 'undefined') return;

        this.$notifyClear(this.noticationTimeStamp);
        this.noticationTimeStamp = [];

        // make sure we don't show alert message repeatedly
        if (this.shouldShowAlertMessage && this.recordData && this.recordData.id) {
          this.shouldShowAlertMessage = false;
          if (
            this.recordData
            && this.recordData.alert
            && this.$route
            && this.$route.meta.tab != 'products'
          ) {
            let timeStamp = this.$notify({
              title: "Account Alert",
              message: this.recordData.alert,
              icon: "work",
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
              
            });
            this.noticationTimeStamp.push(timeStamp);
          }          
        }

        this.getOwnershipTypeEnumOptions(data);
        //State and Country dropdown options:
        this.getCountryEnumOptions(data);
        this.getRegionEnumOptions(data);

        //ATLAS-1262: get Account data to pass on AddProductModal popup
        if (data && data.getAccount && data.getAccount.id) {
          this.productsList.addProductAccountInModal = {
            id: data.getAccount.id,
            name: data.getAccount.name
          }
        }

        // Update the accountCompanyId auto-complete
        (($this) => {
          //$this.data = data.listCompanys.items;
          $this.data = [];

          if (this.recordData && this.recordData.company) {
            // $this.select(formData.company);
            $this.searchTerm = this.recordData.company.name;
            this.$v.form.accountCompanyId.$model = this.recordData.company.id;
          } else {
            //if navigated to Add Account page from Company > Accounts tab > ADD
            if (this.$route.query.accountCompanyId) {
              let companyId = this.$route.query.accountCompanyId;
              this.getCompany(companyId)
                .then(response => {
                  if (response) {
                    $this.searchTerm = response.name;
                    this.$v.form.accountCompanyId.$model = response.id;
                  }
                })
                .catch(err => console.log('getCompany error ', err));
            }
          }
        })(this.formConfig.fields.accountCompanyId);

        if (this.recordData) {
          console.log('this.recordData ',this.recordData.approvalDate)
          if (this.recordData.approvalDate) {
            // this.form.approvalDate = new Date(formData.approvalDate);
            this.$v.form.approvalDate.$model = new Date(this.recordData.approvalDate);
            // this.$v.form.approvalDate.$reset();
          }
        }

        // get Account services
        let services = [];
        if (typeof data.getAccount !== 'undefined' && typeof data.getAccount.services !== 'undefined' && typeof data.getAccount.services.items !== 'undefined' && data.getAccount.services.items.length) {
          this.$loopo(data.getAccount.services.items, (service) => {
            services.push(service);
          });
          this.accountServices = services;
        }

        // this.$nextTick(() => {
        //   this.$c.log('next tick');
        //   setTimeout(() => {
        //     this.$c.log('reset');
        //     this.$v.$reset();
        //   }, 1000);
        //   // TODO: This is a hack. approvalDate and autoComplete fields seem to update themselves async so they end up being dirty even after reset without the 1000 wait
        //
        //   setTimeout(() => {
        //     if (this.$v.form.approvalDate.$dirty || this.$v.form.approvalDate.$anyDirty) {
        //      this.$c.log('Please let developer know race condition is present on form.');
        //     }
        //   }, 1500);
        // })
      },
      getOwnershipTypeEnumOptions(data) {
        this.ownershipTypeOptions = [];
        if (data.listOwnershipTypeEnum && data.listOwnershipTypeEnum.enumValues) {
          data.listOwnershipTypeEnum.enumValues.map(_value => {
            this.ownershipTypeOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          //console.log('this.ownershipTypeOptions: ',this.ownershipTypeOptions);
          this.formConfig.fields.ownershipType.options = this.ownershipTypeOptions;
        }
      },
      /**
       * ATLAS-848 Make "State" a drop down and not an open field
       * Methods for State & Country dropdown
       */
      getRegionEnumOptions(data) {
        this.regionOptions = [];
        if (data.listStatesEnum && data.listStatesEnum.enumValues) {
          data.listStatesEnum.enumValues.map(_value => {
            let _name = _value.name.replace(/US_|CA_/g, '');
            this.regionOptions.push({
              id: _value.name,
              name: _name.replace(/\_/g, ' ')
            });
          });
          
          //console.log('this.regionOptions: ',this.regionOptions);
          this.formConfig.fields.addressPhysical.fields.region.options = this.regionOptions;
          this.formConfig.fields.addressMailing.fields.region.options = this.regionOptions;
        }
      },
      getCountryEnumOptions(data) {
        this.countryOptions = [];
        if (data.listCountriesEnum && data.listCountriesEnum.enumValues) {
          data.listCountriesEnum.enumValues.map(_value => {
            let _name = _value.name.replace(/US_|CA_/g, '');
            this.countryOptions.push({
              id: _value.name.replace(/_United_States|_Canada/g,''),
              name: _name.replace(/\_/g, ' ')
            });
          });
          
          //console.log('this.countryOptions: ',this.countryOptions);
          this.formConfig.fields.addressPhysical.fields.country.options = this.countryOptions;
          this.formConfig.fields.addressMailing.fields.country.options = this.countryOptions;
        }
      },
      onAddNewPerson() {
        this.$refs.accPersonsList.refresh();
      },
      onOpenPopup() {
        this.relatePersonsList.showPopupModal = true; 
        this.relatePersonsList.createNew = true; 
        this.relatePersonsList.selectedItem = null; 
        this.relatePersonsList.afterAdd = null;
      },
      orderedAuditLog: function(items) {
        return _.orderBy(items, "createdAt", "desc");
      },
      onShowAuditLog() {
        this.auditLogDialog = true;
      },
      openMergeDialog() {
        if(this.accountServices.length)
          this.mergeDialog = true;
        else {
          this.alertDialog.show = true;
          this.alertDialog.title = "Account cannot be merged.";
          this.alertDialog.message = "No service linked to account.";
        }
      },
      closeMergeDialog() {
        this.mergeDialog = false;
      },
      getLinkConfigs() {
        if (this.$Session.isAdminGroupMember) {
          this.auditLogList.linkConfigs = [
            {
              name: 'user',
              hrefCallback: (column, name, item) => {               
                return '#/users/' + (item.user ? item.userId : "" );
              },
              titleCallback: (column, name, item) => {                           
                  return item.user                
              },
            }
          ]

          if (this.$refs.auditLogListRef) {
            this.$refs.auditLogListRef.refresh();
          }

        }
      },
      /**
       * Validate account company selection
       * @param {String} value the selected company ID
       * @returns {Promise}
       */
      async isAccountCompanyIdValid(value) {
        // normalized value
        const valueNormalized = value.toString().trim();
        
        // current field
        const field = this.formConfig.fields.accountCompanyId;
        
        // value is empty and there is no search term
        if (!valueNormalized && !field.searchTerm) {
          return true;
        }
        console.log(field.searchTerm);
        
        // clear existing timeout
        clearTimeout(field.timeoutId);
        
        // query name
        const queryName = 'getCompany';
        
        // run new validation
        return new Promise(async (resolve, reject) => {
          field.timeoutId = setTimeout(() => {
            API.graphql(graphqlOperation(queries[queryName], { id: valueNormalized }))
              .then(res => {
                const name = this.$reduce(res, `data.${queryName}.name`);
                if (name === field.searchTerm) {
                  return resolve(true);
                }
                return reject(false);
              })
              .catch(err => {
                return reject(false);
              })
          }, 500);
        });
      },
      /**
       * ATLAS-1856: Company > Account tab: Company record is not getting populated on Add Account
       * 
       * Query getCompany for Company Autocomplete field when $route.query.accountCompanyId exist
       */
      async getCompany(companyId) {
        return new Promise((resolve, reject) => {
          let result = {};
          API.graphql(graphqlOperation(queries['getCompany'], {id: companyId}))
            .then(response => {
              result.id = response.data.getCompany.id;
              result.name = response.data.getCompany.name;
              resolve(result);
            })
            .catch(error => {
              this.$c.log(error);
              resolve(null);
            });
        })
      },
    },
    watch: {
      /**
       * ATLAS-848 Make "State" a drop down and not an open field
       * 
       * Following four watchers will set the Country based on State selection &
       * load specific State list based on Country selection
       */
      "$v.form.addressPhysical.fields.region.$model": {
        immediate: true,
        handler: function() {
          if (this.form.addressPhysical.fields.region) {
            let countryCode = this.form.addressPhysical.fields.region.split("_");
            this.form.addressPhysical.fields.country = countryCode[0];
          }
        }                       
      },
      "$v.form.addressPhysical.fields.country.$model": {
        immediate: true,
        handler: function() {
          if (this.form.addressPhysical.fields.country) {
            if (this.addrPhysicalCountry && this.addrPhysicalCountry != this.form.addressPhysical.fields.country) {
              this.form.addressPhysical.fields.region = "";
            }

            let newRegionOptions = [];
            this.regionOptions.forEach(item => {
              if(item.id.includes(this.form.addressPhysical.fields.country + "_")) {
                newRegionOptions.push(item);
              }
            });

            this.addrPhysicalCountry = this.form.addressPhysical.fields.country;
            this.formConfig.fields.addressPhysical.fields.region.options = newRegionOptions;
          }
        }                       
      },
      "$v.form.addressMailing.fields.region.$model": {
        immediate: true,
        handler: function() {
          if (this.form.addressMailing.fields.region) {
            let countryCode = this.form.addressMailing.fields.region.split("_");
            this.form.addressMailing.fields.country = countryCode[0];
          }
        }                       
      },
      "$v.form.addressMailing.fields.country.$model": {
        immediate: true,
        handler: function() {
          if (this.form.addressMailing.fields.country) {
            if (this.mailingCountry && this.mailingCountry != this.form.addressMailing.fields.country) {
              this.form.addressMailing.fields.region = "";
            }

            let newRegionOpts = [];
            this.regionOptions.forEach(item => {
              if(item.id.includes(this.form.addressMailing.fields.country + "_")) {
                newRegionOpts.push(item);
              }
            });

            this.mailingCountry = this.form.addressMailing.fields.country;
            this.formConfig.fields.addressMailing.fields.region.options = newRegionOpts;
          }
        }
      },
      '$route.params': function () {
        this.$notifyClear(this.noticationTimeStamp);
        this.noticationTimeStamp = [];
        this.shouldShowAlertMessage = true;
      },
      '$Session.isAdminGroupMember'(){
        this.getLinkConfigs();
      },
    }
  }
</script>

<style lang="scss">

  .md-dialog.__alertDialog.md-theme-default {
    width: 50% !important;
  }
  .md-tabs .md-tabs-navigation {
    padding-left: 15px;
    color: black;
    display: flex;

    .md-tab-nav-button.md-button {
      color: black !important;

      &.active {
          color: black !important;
          border-bottom: 2px solid black;
       }
    }
  }

  .md-content .md-tabs-container .md-tab > .md-layout-item {
    padding-left: 0;
    padding-right: 0;
  }

  div:first-child > fieldset:first-child > legend> h5.card-title {
      margin-top: 0;
  }
</style>
